import React from 'react'
import styled, { css } from 'styled-components'
import { Content } from '../shared'
import { AdminHeader } from './adminHeader'

export const AdminLayout = ({ children, title, containerVariant }) => {
  const hasTitle = React.useMemo(() => Boolean(title), [title])

  return (
    <Root>
      <AdminHeader />
      <Container hasTitle={hasTitle}>
        {title}
        <StyledContent variant={containerVariant}>{children}</StyledContent>
      </Container>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 100%;
  width: 100%;
  min-height: 100%;
`

const Container = styled.div`
  display: grid;
  grid-template-rows: ${({ hasTitle }) => (hasTitle ? 'auto 1fr' : '1fr')};
  grid-template-columns: 100%;
  width: 100%;
  gap: 40px;
  padding-bottom: 90px;

  ${({ hasTitle }) =>
    hasTitle &&
    css`
      margin-top: 40px;
    `};
`

const StyledContent = styled(Content)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 40px;
  background-color: #ffffff;

  @media (max-width: 639px) {
    padding: 0 24px;
  }
`
